'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hr_HR = require('../vc-pagination/locale/hr_HR');

var _hr_HR2 = _interopRequireDefault(_hr_HR);

var _hr_HR3 = require('../date-picker/locale/hr_HR');

var _hr_HR4 = _interopRequireDefault(_hr_HR3);

var _hr_HR5 = require('../time-picker/locale/hr_HR');

var _hr_HR6 = _interopRequireDefault(_hr_HR5);

var _hr_HR7 = require('../calendar/locale/hr_HR');

var _hr_HR8 = _interopRequireDefault(_hr_HR7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'hr',
  Pagination: _hr_HR2['default'],
  DatePicker: _hr_HR4['default'],
  TimePicker: _hr_HR6['default'],
  Calendar: _hr_HR8['default'],
  global: {
    placeholder: 'Molimo označite'
  },
  Table: {
    filterTitle: 'Filter meni',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Označi trenutnu stranicu',
    selectInvert: 'Invertiraj trenutnu stranicu',
    sortTitle: 'Sortiraj'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Odustani',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Odustani'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Pretraži ovdje',
    itemUnit: 'stavka',
    itemsUnit: 'stavke'
  },
  Upload: {
    uploading: 'Upload u tijeku...',
    removeFile: 'Makni datoteku',
    uploadError: 'Greška kod uploada',
    previewFile: 'Pogledaj datoteku',
    downloadFile: 'Preuzmi datoteku'
  },
  Empty: {
    description: 'Nema podataka'
  },
  Icon: {
    icon: 'ikona'
  },
  Text: {
    edit: 'uredi',
    copy: 'kopiraj',
    copied: 'kopiranje uspješno',
    expand: 'proširi'
  }
};